import {createElement, ReactElement} from 'react';
import {Control} from 'react-hook-form';

import {isNotNilOrEmpty} from 'ramda-adjunct';

import {
  BaseVehicle,
  ServiceVehicleValidationSchema,
  StepBoundary,
  useBaseVehicleWizard,
  useWizardIndicators,
  useDebouncedWatch,
} from '@dms/features/vehicle-forms-kit';
import i18n from '@dms/i18n';

const stepIds = ['serviceIntervals'] as const;

export const useServiceVehicleWizard = (
  control: Control<BaseVehicle>,
  stepContents: {
    basicInformation: ReactElement;
    vehicleData: ReactElement;
    features: ReactElement;
    serviceIntervals: ReactElement;
  }
) => {
  const wizardSteps = useBaseVehicleWizard({
    basicInformation: stepContents.basicInformation,
    vehicleData: stepContents.vehicleData,
    features: stepContents.features,
  });

  // Debounce serviceIntervals to reduce performance impact when service interval fields change
  const serviceIntervals = useDebouncedWatch(control, ['serviceIntervals'], 300)[0];

  const areServiceIntervalsFilled = Object.values(serviceIntervals ?? {})
    // @ts-expect-error
    .flatMap((item) => Object.values(item))
    .some((item) => isNotNilOrEmpty(item));

  const indicators = useWizardIndicators({stepIds, schema: ServiceVehicleValidationSchema});

  return [
    ...wizardSteps,
    {
      title: i18n.t('entity.vehicle.labels.serviceIntervals'),
      content: createElement(StepBoundary, {id: 'serviceIntervals'}, stepContents.serviceIntervals),
      subtitle: areServiceIntervalsFilled ? undefined : i18n.t('general.labels.notSpecified'),
      isBold: true,
      severity: indicators.serviceIntervals?.severity,
    },
  ];
};
